import { Link } from "react-router-dom";
import { Mail, MessageCircle, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { useI18n } from "../../lib/i18n";

const Col = ({ title, links }) => (
  <div>
    <h4 className="mb-3 text-sm font-bold !text-white">{title}</h4>
    <ul className="space-y-1.5">
      {links.map(([label, to]) => (
        <li key={label}><Link to={to} className="text-sm text-white/75 transition-colors hover:text-white">{label}</Link></li>
      ))}
    </ul>
  </div>
);

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="mt-16 bg-osk-navy text-white" data-testid="site-footer">
      <div className="osk-container grid gap-10 py-12 md:grid-cols-[1.4fr_repeat(4,1fr)_1.3fr]">
        <div className="space-y-3">
          <Logo light showTagline={false} testid="footer-logo" />
          <p className="max-w-[200px] text-sm text-white/75">{t("tagline")}</p>
        </div>
        <Col title={t("nav.lessons")} links={[[t("nav.all"), "/lessen"], [t("footer.byType"), "/lessen?school_type=HAVO"], [t("footer.bySubject"), "/lessen?subject=Wiskunde"]]} />
        <Col title={t("nav.how")} links={[[t("footer.steps"), "/hoe-het-werkt"], [t("footer.pay"), "/hoe-het-werkt#betalen"], [t("footer.faq"), "/hoe-het-werkt#faq"]]} />
        <Col title={t("nav.teachers")} links={[[t("footer.become"), "/docent-worden"], [t("nav.how"), "/voor-docenten"], [t("footer.benefits"), "/voor-docenten#voordelen"]]} />
        <div>
          <h4 className="mb-3 text-sm font-bold !text-white">{t("footer.contact")}</h4>
          <p className="flex items-center gap-2 text-sm text-white/75" data-testid="footer-email"><Mail className="h-4 w-4 text-osk-yellow" /> info@onskola.com</p>
          <p className="mt-2 flex items-center gap-2 text-sm text-white/75" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4 text-osk-yellow" /> WhatsApp +297 000 0000</p>
        </div>
        <div>
          <h4 className="mb-3 text-sm font-bold !text-white">{t("footer.islands")}</h4>
          <p className="flex items-center gap-2 text-sm text-white/75"><MapPin className="h-4 w-4" />{t("footer.now")} <span className="osk-pill bg-osk-yellow text-osk-navy">Aruba</span></p>
          <p className="mt-2 text-sm text-white/75">{t("footer.soon")}</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="osk-container flex flex-col gap-3 py-5 text-xs text-white/60 md:flex-row md:items-center md:justify-between">
          <span>© {new Date().getFullYear()} Onskola</span>
          <div className="flex flex-wrap gap-5">
            <Link to="/voorwaarden/ouders" className="hover:text-white" data-testid="footer-parent-terms">{t("legal.parent")}</Link>
            <Link to="/voorwaarden/docenten" className="hover:text-white" data-testid="footer-teacher-terms">{t("legal.teacher")}</Link>
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">{t("legal.privacy")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
